import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeBody02, typeBody03, typeLabel01, typeHeading05 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { unit, spacer, mediaQuery, SIZE, maxWidth } from '../../theme/metrics'
import { GREY_01, BLACK_01, BLUE_01, WHITE_01 } from '../../theme/colors'

export const Container = styled.footer`
	display: block;
	background-color: ${WHITE_01};
`

export const Navigation = styled.nav`
	${grid}
	max-width: ${maxWidth()};
	margin: 0 auto;
`

export const NavigationList = styled.ul`
	${row({large:true})}
	padding-top: ${unit(8)};
	padding-bottom: ${unit(8)};
	border-bottom: 1px solid ${GREY_01};

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(3)};
		padding-bottom: ${spacer(3)};
	}
`

export const NavigationListItem = styled.li`
	${props => column({large:{span:2}},{direction:props.theme.direction})}
`

export const Link = styled.a`
	display: block;
	text-decoration: none;
	color: ${BLACK_01};
	transition: 0.3s;

	&:hover{
		opacity: 0.6;
	}
`

export const Group = styled.div`
	display: block;
	margin-bottom: ${spacer(1)};

	${mediaQuery[SIZE.large]}{
		margin-bottom: 0;
	}
`

export const GroupHeader = styled.div`
	${typeLabel01}
	display: block;
	margin-bottom: ${unit(4)};
	color: ${BLUE_01};

	${Link}{
		color: ${BLUE_01};
	}
`

export const GroupList = styled.ul`
	display: block;
`

export const GroupListItem = styled.li`
	${typeHeading05}
	display: block;
	margin-bottom: ${unit(2)};

	&:last-child{
		margin-bottom: 0;
	}
`

export const BottomContainer = styled.div`
	${grid}
	max-width: ${maxWidth()};
	margin: 0 auto;
`

export const BottomInner = styled.div`
	${row({large:true})}
	padding-top: ${spacer(1)};
	padding-bottom: ${spacer(1)};
`

export const LegalContent = styled.div`
	${props => column({large:{span:6}},{direction:props.theme.direction})}
`

export const Legal = styled.div`
	${typeBody03}
	margin-top: ${spacer(1)};
	color: ${BLACK_01};

	${mediaQuery[SIZE.large]}{
		margin-top: 0;
	}

	> p{
		margin-bottom: ${unit(2)};

		&:last-child{
			margin-bottom: 0;
		}
	}

	> ul{
		margin-bottom: ${unit(2)};
		margin-left: ${unit(-1)};
		margin-right: ${unit(-1)};


		&:last-child{
			margin-bottom: 0;
		}

		> li{
			margin-left: ${unit(1)};
			margin-right: ${unit(1)};
			display: inline-block;
		}
	}

	a{
		color: ${BLACK_01};
		transition: 0.3s;

		&:hover{
			opacity: 0.6;
		}
	}
`

export const Social = styled.li`
	${props => column({large:{span:2,before:props.space * 2}},{direction:props.theme.direction})}
	
`

export const SocialList = styled.ul`
	display: flex;

	${mediaQuery[SIZE.large]}{
		justify-content: flex-end;
	}
`

export const SocialItem = styled.li`
	margin-right: ${unit(3)};

	&:last-child{
		margin-right: 0;
	}
`

export const SocialLink = styled.a`
	display: block;
`

export const SocialIcon = styled.img`
	display: block;
	width: ${unit(4)};
	height: ${unit(4)};
`